module.exports = __webpack_public_path__ + "static/media/icon-manage-class-student-list-plan-standard.80c4b3bf.svg";